<script>
export default {
  name: 'language-select',
  props: {
    value: {
      type: String
    }
  },
  data: () => ({ selected: null }),
  watch: {
    value: {
      handler (v) {
        this.selected = v
      },
      immediate: true
    }
  },
  computed: {
    languages () {
      return [
        { value: 'en', text: 'English' },
        { value: 'nl', text: 'Nederlands' },
        { value: 'fr', text: 'Français' },
        { value: 'de', text: 'Deutsch' }
      ]
    }
  },
  methods: {
    onInputHandler (v) {
      this.$emit('input', v)
    }
  }
}
</script>
<template>
  <b-form-select
    v-model="selected"
    :options="languages"
    v-on:input="onInputHandler"
  ></b-form-select>
</template>
